var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('agency-agency-projects-list',{staticClass:"approved-agency-projects-view",attrs:{"header":"Wszystkie projekty w krajach placówki","icon":"business","empty-warning":"Nie ma jeszcze żadnego projektu w krajach placówki"}})}
var staticRenderFns = []

export { render, staticRenderFns }